var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"white-nav-bar"},[_c('h2',[_vm._t("default")],2),_c('router-link',{staticClass:"nav-back",class:_vm.backOrClose,attrs:{"to":{
			name: _vm.routeName,
			params: {
				direction: _vm.direction
			}
		}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }